"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const _config_json_1 = __importDefault(require("./_config.json"));
exports.default = {
    deadlines: _config_json_1.default.commonConfig.deadlines,
    eatingTimes: _config_json_1.default.commonConfig.eatingTimes
};
